module.exports = __webpack_public_path__ + "static/media/voxar-logo-gray.de8c5422.png";